<template>
    <div>
        <div class="mx-auto my-2 w-100">
            <h3>Группы работ</h3>
        </div>
        <div class="d-flex justify-content-end my-2">
            <b-button
                    v-b-modal.groupWorkModal
                    size="sm"
                    variant="success"
                    v-if="$can('create', 'workGroups')"
            >
                Создать группу работ
            </b-button>
        </div>
        <b-row class="my-2 align-items-center">
            <b-col cols="12" md="6" class="mb-2 mb-md-0">
                <b-input-group size="sm">
                    <b-form-input
                            v-model="filter"
                            type="search"
                            id="filterInput"
                            placeholder="Введите для поиска"
                    ></b-form-input>
                </b-input-group>
            </b-col>
            <b-col cols="12" md="6">
                <div class="d-flex flex-wrap justify-content-md-end align-items-center">
                    <b-pagination
                            v-model="currentPage"
                            :total-rows="totalRows"
                            :per-page="perPage"
                            align="fill"
                            size="sm"
                            class="my-0 mb-2 mb-md-0 mr-2"
                    ></b-pagination>
                    <div class="mb-2 mb-md-0">
                        <b-form-group
                                label="На странице"
                                label-cols="6"
                                label-size="sm"
                                label-for="perPageSelect"
                                class="mb-0 d-flex align-items-center"
                        >
                            <b-form-select
                                    v-model="perPage"
                                    id="perPageSelect"
                                    size="sm"
                                    :options="pageOptions"
                            ></b-form-select>
                        </b-form-group>
                    </div>
                </div>
            </b-col>
        </b-row>
        <b-table
                responsive="sm"
                :fields="fields"
                striped
                small
                :items="items"
                :current-page="currentPage"
                :per-page="perPage"
                @filtered="onFiltered"
                :filter="filter"
                sticky-header="80vh"
        >
            <template v-slot:cell(actions)="data">
                <i class="fas fa-pen text-center text-success mx-2"
                   @click="onEditClick(data)"
                   v-if="$can('update', 'workGroups')"
                ></i>
            </template>
        </b-table>
        <b-modal id="groupWorkModal"
                 title="Создание группы работ"
                 @ok="submit()"
                 @hide="clearItem()"
                 ok-title="Ок"
                 ok-variant="success"
                 cancel-title="Отмена"
                 cancel-variant="danger"
                 no-close-on-backdrop
        >
            <WorkGroupItem :item="item" ref="workGroupRef"/>
        </b-modal>
    </div>
</template>

<script>
    import WorkGroupItem from "./WorkGoupItem/WorkGroupItem.vue";

    export default {
        components: {
            WorkGroupItem
        },
        computed: {
            items() {
                return this.$store.state.workGroups;
            }
        },
        data() {
            return {
                fields: [
                    {
                        key: `name`,
                        label: `Имя`,
                        sortable: true
                    },
                    {
                        key: `group`,
                        label: `Группа`,
                        sortable: true
                    },
                    {
                        key: `unit`,
                        label: `Ед. изм.`,
                        sortable: true
                    },
                    {
                        key: `method`,
                        label: `Метод`,
                        sortable: true
                    },
                    {
                        key: `target`,
                        label: `Целевой объект`,
                        sortable: true
                    },
                    {
                        key: `material`,
                        label: `Материал`,
                        sortable: true
                    },
                    {
                        key: `equipment`,
                        label: `Инструмент`,
                        sortable: true
                    },
                    {
                        key: `actions`,
                        label: ``,
                        sortable: false
                    }
                ],
                isEdit: false,
                item: null,
                filter: null,
                perPage: 200,
                pageOptions: [5, 10, 15, 20, 100, 200],
                totalRows: 1,
                currentPage: 1,
                filterOn: []
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            init() {
                this.$store.dispatch(`getWorkGroups`);
                this.totalRows = this.items.length;
            },
            async submit() {
                const data = this.$refs.workGroupRef.$data;
                if (this.item) {
                    await this.editGroup(data);
                } else {
                    await this.createGroup(data);
                }
                this.init();
            },
            clearItem() {
                this.item = null;
            },
            onEditClick({item}) {
                this.item = item;
                this.$bvModal.show(`groupWorkModal`);
            },
            createGroup(data) {
                this.$store.dispatch(`createWorkGroup`, data);
            },
            editGroup(data) {
                const {id} = this.item;
                this.$store.dispatch(`editWorkGroup`, {id, data});
            },
            onFiltered(filteredItems) {
                this.totalRows = filteredItems.length
                this.currentPage = 1
            }
        },
        name: "WorkGroups"
    }
</script>

<style scoped>

</style>